import { CuerpoDocumentoItem, TotalsCalculation } from '../types/facturaTypes';
import { parseNumberToFixed2 } from '../../../utils/ParseNumer/parseNumber2Digits';

export const calculateTotals = (cuerpoDocumento: CuerpoDocumentoItem[]): TotalsCalculation => {
  return cuerpoDocumento.reduce((acc, item) => {
    const subtotal = Math.round((item.cantidad * item.precioUni) * 100) / 100;
    const descuento = Math.round((item.montoDescu || 0) * 100) / 100;
    const ventaGravada = parseNumberToFixed2(item.ventaGravada);
    const iva = parseNumberToFixed2(item.ivaItem);
    
    return {
      subtotal: Math.round((acc.subtotal + subtotal) * 100) / 100,
      descuento: Math.round((acc.descuento + descuento) * 100) / 100,
      ventaGravada: Math.round((acc.ventaGravada + ventaGravada) * 100) / 100,
      iva: Math.round((acc.iva + iva) * 100) / 100,
      total: Math.round((acc.total + (subtotal - descuento + iva)) * 100) / 100
    };
  }, { subtotal: 0, descuento: 0, ventaGravada: 0, iva: 0, total: 0 });
};

export const formatCurrency = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') return '';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '';
  
  // Redondear a 2 decimales para evitar problemas de floating point
  const rounded = Math.round(numValue * 100) / 100;
  
  return `$${rounded.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const parseCurrency = (value: string | undefined): string => {
  if (!value) return '';
  return value.replace(/\$\s?|(,*)/g, '');
};
